// src/components/ui/HoverNav.jsx

import React, { useState } from 'react';
import { PAGE } from './pageTheme';

export default function HoverNav({
  children,
  onPrev,
  onNext,
  disabledPrev,
  disabledNext,
}) {
  const [hover, setHover] = useState(false);

  const buttonStyle = (side, disabled) => ({
    position: 'absolute',
    top: '50%',
    [side]: 14,
    transform: 'translateY(-50%)',
    zIndex: 30,

    minWidth: 78,
    height: 36,
    padding: '0 12px',
    borderRadius: 999,
    border: `1px solid ${PAGE.colors.line}`,
    background: 'rgba(255, 255, 255, 0.78)',
    color: PAGE.colors.text,
    backdropFilter: 'blur(10px)',
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.14)',

    fontSize: 12,
    fontWeight: 800,
    cursor: disabled ? 'not-allowed' : 'pointer',

    opacity: hover ? (disabled ? 0.35 : 1) : 0,
    pointerEvents: hover && !disabled ? 'auto' : 'none',

    transition:
      'opacity 180ms cubic-bezier(.2,.9,.2,1), transform 180ms cubic-bezier(.2,.9,.2,1)',
  });

  return (
    <div
      style={{
        position: 'relative',
        flex: 1,
        minHeight: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {children}

      <button
        type="button"
        onClick={onPrev}
        disabled={disabledPrev}
        style={buttonStyle('left', disabledPrev)}
      >
        ← Prev
      </button>

      <button
        type="button"
        onClick={onNext}
        disabled={disabledNext}
        style={buttonStyle('right', disabledNext)}
      >
        Next →
      </button>
    </div>
  );
}